import React from "react";
import styled from "styled-components";
import { reduxForm } from "redux-form";
import { Field, Form } from "redux-form";

import { FormInput } from "../../../common/components";
import strings from "../../../../res/strings";

const Title = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 2em;
  line-height: 73px;
  letter-spacing: 0.1em;

  color: #929292;
  text-align: center;
`;
const ChangePasswordFormContentContainer = styled(Form)`
  padding: 15%;
  padding-top: 25vh;
`;
const ChangePasswordFormContent = styled.div`
  padding: 0px 16px 16px 16px;
`;
const ChangePasswordButtons = styled.div`
  padding: 24px 24px 24px 24px;
`;
const ChangePasswordSubmitButton = styled.button`
  width: 100%;
  background: #039095;
  border-radius: 250.251px;
  font-size: 1.5em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
`;
const FieldsContainer = styled.div`
  margin-top: 16px;
`;
const RouterLink = styled.a`
  color: #929292;
  font-family: Secular One;
  cursor: pointer;

  :hover {
    color: #7a7a7a;
  }
`;
const BackToLoginContent = styled.div`
  margin-top: 16px;
  width: 100%;
  text-align: center;
`;

let ChangePasswordForm = (props) => {
  return (
    <ChangePasswordFormContentContainer onSubmit={props.handleSubmit}>
      <ChangePasswordFormContent>
        <Title>RESET PASSWORD</Title>

        <FieldsContainer>
          {props.oldPasswordVisible && (
            <Field
              name="oldPassword"
              component={FormInput}
              label={strings.lib_authentication_label_password_old}
              type="password"
              required
              minlength={8}
              maxlength={128}
              placeholder={"OLD PASSWORD"}
            />
          )}
          <Field
            name="newPassword"
            component={FormInput}
            label={strings.lib_authentication_label_password_new}
            type="password"
            required
            minlength={8}
            maxlength={128}
            placeholder={"NEW PASSWORD"}
          />

          <Field
            name="confirmNewPassword"
            label={strings.lib_authentication_label_password_new_confirm}
            type="password"
            required
            component={FormInput}
            placeholder={"CONFIRM NEW PASSWORD"}
          />
        </FieldsContainer>
        <ChangePasswordButtons>
          <ChangePasswordSubmitButton type="submit" color="primary" required>
            {props.oldPasswordVisible ? "CHANGE PASSWORD" : "SAVE NEW PASSWORD"}
          </ChangePasswordSubmitButton>
        </ChangePasswordButtons>
      </ChangePasswordFormContent>
      <BackToLoginContent>
        <RouterLink
          onClick={() => {
            props.setRightPanel("LOGIN");
          }}
        >
          Go back to Login
        </RouterLink>
      </BackToLoginContent>
    </ChangePasswordFormContentContainer>
  );
};

const ReduxChangePasswordForm = reduxForm({
  form: "lib_authentication_change_password",
})(ChangePasswordForm);

export default ReduxChangePasswordForm;
